export default __webpack_public_path__ + "static/media/arrow-1.e50b7ddf.e50b7ddf.png";